import type { IStyle } from 'fela';

import type { Theme } from '../types';

// Sidebar left, content right. Collapses to one column on narrow screens, where
// a fixed menu column would squeeze the article titles.
export const layout: IStyle = {
  display: 'grid',
  gridTemplateColumns: 'minmax(220px, 280px) minmax(0, 1fr)',
  alignItems: 'start',
  gap: '32px',
  '@media (max-width: 800px)': {
    gridTemplateColumns: 'minmax(0, 1fr)'
  }
};

export const menu: IStyle = {
  padding: '12px',
  backgroundColor: '#ffffff',
  border: '1px solid rgba(2, 20, 13, 0.12)',
  borderRadius: '24px',
  boxShadow: '0 8px 30px rgba(2, 20, 13, 0.05)'
};

export const heading: (theme?: Theme) => IStyle = (theme) => ({
  margin: 0,
  padding: '10px 14px',
  fontSize: '1.1rem',
  fontWeight: 'bold',
  fontFamily: theme?.header?.font?.family ?? 'inherit'
});

export const row: (theme?: Theme, isCurrent?: boolean) => IStyle = (theme, isCurrent) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  padding: '10px 14px',
  borderRadius: '12px',
  color: 'inherit',
  textDecoration: 'none',
  fontWeight: isCurrent ? 'bold' : 'normal',
  backgroundColor: isCurrent ? theme?.button?.style?.backgroundColor ?? '#cfff92' : 'transparent',
  ':hover': {
    backgroundColor: isCurrent ? theme?.button?.style?.backgroundColor ?? '#cfff92' : 'rgba(2, 20, 13, 0.05)'
  }
});

export const label: IStyle = {
  flexGrow: 1,
  minWidth: 0
};

export const chevron: IStyle = {
  flexShrink: 0,
  opacity: 0.5
};
